/** @format */

import {ReactElement} from 'react';

import {Typography} from '@mui/material';

import {ExpenditureMode} from '../../interfaces';
import {content} from './constants';
import {TooltipContentContainer} from './styles';

interface TooltipContentProps {
  mode: ExpenditureMode;
}

export const TooltipContent = ({mode}: TooltipContentProps): ReactElement => {
  const getDescriptions = () => {
    return content?.[mode]?.descriptions.map((description, index) => (
      <Typography key={index} sx={{mb: 1}}>
        {description}
      </Typography>
    ));
  };

  return (
    <TooltipContentContainer>
      <Typography sx={{mb: 1}}>{content[mode]?.title}</Typography>
      {getDescriptions()}
    </TooltipContentContainer>
  );
};
